import { Component, OnInit } from '@angular/core';
import {environment} from "../../../environments/environment";
import {AuthenicationService} from "../../_services/authenication.service";
import {ActivatedRoute, Router} from "@angular/router";
import {ContactusService} from "../../_services/contactus.service";
import {ToasterService} from "../../_services/toaster.service";
import {ExcelServicesService} from "../../_services/excel-services.service";
import {Ng4LoadingSpinnerService} from "ng4-loading-spinner";
declare var $: any;

@Component({
  selector: 'app-organisation-list',
  templateUrl: './organisation-list.component.html',
  styleUrls: ['./organisation-list.component.css']
})
export class OrganisationListComponent implements OnInit {

  userdetaild: string;
  baseUrl: string = environment.baseUrl;
  returnUrl: string;
  contactlist: any;
  patients_data: any[] = [];
  userId: string;

  constructor(private authenicationService: AuthenicationService, private router: Router, private route: ActivatedRoute, private contactusservice: ContactusService, private toaster: ToasterService,private excelService:ExcelServicesService,private spinnerService: Ng4LoadingSpinnerService) { }

  ngOnInit() {
    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }
    if (!this.userdetaild || this.userdetaild['users_usertype'] == 'employee2') {
      this.router.navigate(['/']);
    }
    this.userId = this.userdetaild['_id'];

    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';

    this.getOrganizations();
  }

  getOrganizations() {

    this.contactusservice.getOrganizations()
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            // this.toaster.showSuccess('Add Doctor', data.ResponseMessage);
            this.contactlist = data.Data;


            setTimeout(() => {
              $(function() {
                $('#example').DataTable();
              });
            }, 1000);
          } else {
            this.toaster.showError('Users', data.ResponseMessage);
            setTimeout( () => {
              $(function() {
                $('#example').DataTable();
              });
            }, 1000);
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          this.toaster.showError('Users', error);
          setTimeout( () => {
            $(function() {
              $('#example').DataTable();
            });
          }, 1000);
        });
  }

  deleteOrganizationById(id) {
    let payload = {
      id: id
    }

    this.contactusservice.deleteOrganizationById(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.toaster.showSuccess('Organisation', data.ResponseMessage);
            this.getOrganizations();

          } else {
            this.toaster.showError('Organisation', data.ResponseMessage);

          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          this.toaster.showError('Organisation', error);

        });
  }

  editOrganization(id, status) {
    let payload = {
      id: id,
      isActive: status,
      userId: this.userId
    }

    this.contactusservice.editOrganization(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.toaster.showSuccess('Organisation', data.ResponseMessage);
            this.getOrganizations();

          } else {
            this.toaster.showError('Organisation', data.ResponseMessage);

          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          this.toaster.showError('Organisation', error);

        });
  }

}
